<script setup lang="ts">
import {ExtendedProject, Role, Token} from "@/types";
import BaseLayout from "@/layouts/BaseLayout.vue";
import ProjectLayout from "@/Pages/projects/layouts/ProjectLayout.vue";
import {route} from "ziggy-js";
import {Head, router} from "@inertiajs/vue3";
import {useFlashData} from "@/composables/flash";
import InfoAlert from "@/components/alerts/InfoAlert.vue";
import TokensList from "@/Pages/projects/tokens/components/TokensList.vue";
import DeleteAllTokensDialog from "@/Pages/projects/tokens/components/DeleteAllTokensDialog.vue";

interface Props {
    project: ExtendedProject,
    role: Role,
    tokens: Array<Token>
}

const props = defineProps<Props>()
defineOptions({
    layout: BaseLayout
})
</script>

<template>
    <Head title="Configure API integration" />
    <project-layout
        :role="props.role"
        :project="props.project"
    >
        <h1 class="font-weight-medium text-h5 mt-5">
            API Integration
        </h1>
        <v-divider class="my-3" />
        <v-card
            :flat="true"
            class="mb-5"
        >
            <v-card-text>
                <v-row>
                    <span class="text-h5 black--text">Manage tokens</span>
                    <v-spacer />
                    <default-btn
                        size="small"
                        class="border font-weight-medium mr-2"
                        rounded="lg"
                        @click="router.visit(route('projects.tokens.create', {project: props.project.slug}))"
                    >
                        Generate new token
                    </default-btn>
                    <delete-all-tokens-dialog
                        v-if="props.tokens.length > 0"
                        :project="props.project"
                    />
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        class="px-0"
                    >
                        <p>
                            Tokens you have generated that can be used to access the <a
                                href="#"
                                target="_blank"
                                class="text-primary"
                            >SendCrypt API</a>.
                        </p>
                        <info-alert
                            v-if="useFlashData.token"
                            class="my-2"
                        >
                            Make sure to copy your personal access token now. You won’t be able to see it again!
                        </info-alert>
                        <tokens-list
                            :project="props.project"
                            :tokens="props.tokens"
                            :temporary-token="useFlashData.token"
                        />
                    </v-col>
                    <v-col
                        cols="12"
                        class="px-0 pt-0"
                    >
                        <div class="text-caption text-disabled mb-3">
                            Personal access tokens can be used to authenticate to the API over Basic Authentication.
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </project-layout>
</template>

<style scoped>

</style>
